module.exports = __webpack_public_path__ + "static/media/a.242e6321.csv";